import MobileListFirstView from '../../new-event-layouts/mobile/list1';
import MobileListSecondView from '../../new-event-layouts/mobile/list2';
import MobileStackFirstView from '../../new-event-layouts/mobile/stack1';
import MobileStackSecondView from '../../new-event-layouts/mobile/stack2';
import MobileCheckoutOnly from '../mobile/checkout-only';

export const mobileLayoutComponent = (settings) => {
  const layoutDesign = settings.get('mobileLayoutDesign');

  const mapping = {
    'mobile-list1': MobileListFirstView,
    'mobile-list2': MobileListSecondView,
    'mobile-stack1': MobileStackFirstView,
    'mobile-stack2': MobileStackSecondView,
    'mobile-checkout': MobileCheckoutOnly,
  };
  return mapping[layoutDesign] || MobileListFirstView;
};
